import React, {useState, useEffect} from 'react'
import {useLocation} from 'react-router-dom'
import {
  Input,
  ParagraphText,
  Button,
  Select,
  Modal,
  ModalTitle,
} from '@thryvlabs/maverick'

import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'
import {Controller} from 'react-hook-form'
// import rawCountryStates from 'iso3166-2-db/i18n/en'
// import validator from 'validator'
import {PhoneNumberUtil} from 'google-libphonenumber'
import * as yup from 'yup'
import {yupResolver} from '@hookform/resolvers/yup'
import {useForm} from 'react-hook-form'
// import {BlueGradientBackground} from '../components/AuthForm'
import {useAuthClient} from '../../utils/use-auth-client'
import {useAsync} from '../../utils/use-async'
import {thryvnkeapLogo} from '../../assets'
// import whiteLettersLogo from '../../assets/thryv-logo-white-letters.svg'

import '../../styles/formScreensStyles.css'
import {
  fetchSelectedCountryRegionList,
  validatePostalCode,
} from '../../utils/address-validation-util'

// Country to currency mapping
const COUNTRY_CURRENCY_MAP = {
  US: 'USD',
  CA: 'CAD',
  GB: 'GBP',
  AU: 'AUD',
  NZ: 'NZD',
}

export const BlueGradientBackground = ({
  showLogo = true,
  backgroundHexColor = '#fff',
  width = '100%',
  className = '',
}) => {
  return (
    <section
      className={`blue-gradient-bg ${className}`}
      style={{
        background: backgroundHexColor,
        width,
      }}
    >
      <div>
        {/* {showLogo && (
          <img
            src={whiteLettersLogo}
            alt="Logo"
            style={{
              maxWidth: '98px',
              marginTop: '24px',
              marginLeft: '24px',
            }}
          />
        )} */}
      </div>
    </section>
  )
}
export function ThryvAndKeapHeader() {
  return (
    <header className="header-container">
      <img src={thryvnkeapLogo} alt="Thryv Keap Logo" className="header-logo" />
    </header>
  )
}
export const KeapPartnerAccountDetails = ({userData}) => {
  const [emailRegistered, setEmailRegistered] = useState(true)
  const [listOfStates, setListOfStates] = useState([])
  const [validatedEmail, setValidatedEmail] = useState('')
  const [showAccountExistsModal, setShowAccountExistsModal] = useState(false)
  const [showUpgradeAccountModal, setShowUpgradeAccountModal] = useState(false)
  const location = useLocation()
  let keapPartnerId = location?.state?.keapPartnerId
  const [selectedCountry, setSelectedCountry] = useState(
    location?.state?.selectedCountry || 'US',
  )
  const isAu = selectedCountry === 'AU'
  const linkType = location?.state?.linkType || '1:1'
  const {run} = useAsync({
    status: 'pending',
  })
  const navigate = useNavigate()
  const client = useAuthClient()
  const phoneUtil = PhoneNumberUtil.getInstance()
  const REQUIRED_FIELD_MESSAGE = 'This field is required'
  const REQUIRED_OPTION_MESSAGE = 'Please select an option'
  const MIN_CHARACTERS_REQUIRED = 'Must be at least 3 characters'
  const MAX_CHARACTERS_REQUIRED = 'Must be at most 120 characters'
  const VALID_EMAIL_MESSAGE = 'Must be a valid email'
  // const VALID_WEBSITE_URL_MESSAGE = 'Please enter a valid url'

  const SCHEMA = yup.object().shape({
    firstName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    lastName: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    email: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .email(VALID_EMAIL_MESSAGE),
    company: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    postCode: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-postCode-format',
        'Incorrect post code format',
        function (value) {
          if (!value) {
            return false
          }
          let postalValidationStatus = validatePostalCode(
            selectedCountry,
            value,
          )
          return postalValidationStatus
        },
      ),
    address: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    city: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(3, MIN_CHARACTERS_REQUIRED)
      .max(120, MAX_CHARACTERS_REQUIRED),
    state: yup.object().shape({
      name: yup.string().required(REQUIRED_OPTION_MESSAGE),
      value: yup.string().required(REQUIRED_OPTION_MESSAGE),
    }),
    mobile: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
    companyPhone: yup
      .string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test(
        'validate-phone-format',
        'Incorrect phone number format',
        function (value) {
          try {
            if (!value) {
              return false
            }
            value = value.replace(/[^\d]/g, '')
            if (selectedCountry === 'US' && value.length > 10) {
              return false
            }
            const parsedPhone = phoneUtil.parse(value, selectedCountry)
            return phoneUtil.isValidNumber(parsedPhone)
          } catch {
            return false
          }
        },
      ),
    abn: yup.string().test('validate-abn', function (value) {
      const country = selectedCountry.toLowerCase()
      if (
        country === 'au' &&
        (!value || value.length !== 11 || !/^\d+$/.test(value))
      ) {
        return this.createError({message: 'Please enter a valid, 11-digit ABN'})
      }
      if (
        country === 'nz' &&
        value &&
        (value.length !== 13 || !/^\d+$/.test(value))
      ) {
        return this.createError({
          message: 'Please enter a valid, 13-digit NZBN',
        })
      }
      return true
    }),
  })
  const DEFAULT_VALUES = {
    email: '',
    prospectEmail: '',
    prospectFirstName: '',
    prospectLastName: '',
  }
  const {
    register,
    formState: {errors},
    control,
    handleSubmit,
    watch,
  } = useForm({
    defaultValues: DEFAULT_VALUES,
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    resolver: yupResolver(SCHEMA),
  })

  useEffect(() => {
    // Populate states based on selected country
    // if (rawCountryStates[selectedCountry]) {
    //   const states = rawCountryStates[selectedCountry].regions
    //     .map(({iso, name}) => ({
    //       name,
    //       value: iso || name,
    //     }))
    //     .sort((a, b) => (a.name > b.name ? 1 : -1))
    //   setListOfStates(states)
    // }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    let data = fetchSelectedCountryRegionList(selectedCountry)
    // console.log(data)
    setListOfStates(data)
  }, [selectedCountry])

  const [email, state] = watch(['email', 'state'])

  const inputClassName = emailRegistered
    ? 'form-input w-full disabled'
    : 'form-input w-full enabled'

  const handleOrderDetailContinue = async formData => {
    try {
      const accountInformation = setData(formData)

      await client('accounts/address/validate', {
        data: {
          address: formData.address,
          city: formData.city,
          state: formData.state.value,
          zipCode: formData.postCode,
          country: selectedCountry,
        },
      })

      navigate('/keap-partner-catalog', {
        state: {
          email: email,
          isUpgrade: false,
          linkType: linkType,
          selectedCountry: selectedCountry,
          accountInformation,
          keapPartnerId: keapPartnerId,
        },
      })
    } catch (err) {
      if (err?.message) {
        toast.error(err.message)
      } else {
        console.log(err)
      }
    }
  }

  const setData = formData => {
    const currency = COUNTRY_CURRENCY_MAP[selectedCountry] || 'USD'
    let data = {
      ...formData,
      country: selectedCountry,
      state: formData.state.value,
      businessAddress: {
        city: formData.city,
        state: formData.state.value,
        country: selectedCountry,
        phone: formData.companyPhone,
        street: formData.address,
        postalCode: formData.postCode,
      },
      contactPhone: formData.mobile,
      currency: currency,
      flow: 'new',
      billTo: formData.billTo || 'self',
      ...(['AU', 'NZ'].includes(selectedCountry) && {abn: formData.abn}),
    }
    return data
  }

  const handlePhoneKeyDown = e => {
    // Block alphabetical characters; allow digits, +, -, (, ), space, and control keys
    if (
      e.key.length === 1 &&
      /[a-zA-Z]/.test(e.key) &&
      !e.ctrlKey &&
      !e.metaKey
    ) {
      e.preventDefault()
    }
  }

  const preventUnvalidatedEmail = () => {
    if (validatedEmail !== email && !emailRegistered) {
      setEmailRegistered(true)
      setValidatedEmail('')
    }
  }
  const handleEmailValidation = async () => {
    const emailRegex = /^[a-zA-Z0-9._+-]+@[^\s@]+\.[^\s@]+$/
    if (emailRegex.test(email)) {
      const isThryvEmail = email.includes('@thryv.com')
      if (isThryvEmail === false) {
        try {
          if (!keapPartnerId) {
            keapPartnerId = userData?.user_metadata?.keapPartnerId
          }
          const response = await run(
            client(
              `orders/validate-email/${email}?fetchSubDetail=true&keapPartnerId=${keapPartnerId}&keapClient=true`,
            ),
          )
          if (response?.orderCanContinue && !response?.thryvId) {
            setValidatedEmail(email)
            setEmailRegistered(false)
          } else if (response?.thryvId && response?.accountCanUpgrade) {
            if (response?.v5upgrade !== true) {
              setShowAccountExistsModal(true)
            } else if ('isValidPartnerAligned' in response) {
              if (response.isValidPartnerAligned) {
                if (response?.subDetails?.address?.country) {
                  setSelectedCountry(response?.subDetails?.address?.country)
                }
                setShowUpgradeAccountModal(true)
              } else {
                setShowAccountExistsModal(true)
                // setShowUpgradeAccountModal(true)
              }
            } else {
              setShowAccountExistsModal(true)
            }
          } else {
            toast.error(
              'Oops! Looks like we already have this email address registered. Please reach out to your Partner representative to confirm enrollment/purchase.',
            )
          }
        } catch (err) {
          toast.error(
            'Oops! Looks like we already have this email address registered. Please reach out to your Partner representative to confirm enrollment/purchase.',
          )
        }
      } else {
        toast.error('Thryv addresses are not allowed')
      }
    } else {
      toast.error('Valid email address required')
    }
  }
  return (
    <>
      <section className="d-flex flex-col flex-wrap align-items-center ">
        <section
          style={{
            backgroundColor: 'white',
            border: '1px solid #ECEEF1',
            borderRadius: '12px',
            display: 'flex',
            flexDirection: 'column',
            boxShadow: '0px 2px 4px 0px #00000040',
            paddingInline: '43px',
            paddingTop: '63px',
            paddingBottom: '45px',
            marginTop: '80px',
            width: '40%',
          }}
        >
          <BlueGradientBackground />
          <section>
            <section className="d-flex justify-content-center">
              <p
                style={{
                  marginBottom: '40px',
                  fontWeight: 700,
                  fontStyle: 'bold',
                  fontFamily: 'Open Sans',
                  fontSize: '32px',
                  lineHeight: '100%',
                  color: 'black',
                }}
              >
                Start Your Client Order
              </p>
            </section>

            <ParagraphText variant="reg" className="section-title">
              Client Account Information{' '}
              <span className="required-field">*</span>
            </ParagraphText>

            <section className="d-flex justify-content-between mt-4 gap-6">
              <div className="w-100">
                <Input
                  type="text"
                  placeholder="Email Address"
                  aria-label="Email Address"
                  name="email"
                  withLabel
                  labelType="floating"
                  variant="default"
                  register={register}
                  errors={errors}
                  onChange={preventUnvalidatedEmail()}
                  style={{
                    opacity: 1,
                  }}
                  className={`w-full ${inputClassName}`}
                />
              </div>
              <div>
                <Button
                  variant="primary"
                  type="button"
                  name="Validate"
                  onClick={handleEmailValidation}
                  className="btn-validate"
                >
                  Next
                </Button>
              </div>
            </section>
            <section className="d-flex justify-content-between mt-4 gap-4">
              <div className="w-full">
                <Input
                  type="text"
                  placeholder="First Name"
                  aria-label="First Name"
                  name="firstName"
                  withLabel
                  labelType="floating"
                  variant="default"
                  register={register}
                  errors={errors}
                  disabled={emailRegistered}
                  className={inputClassName}
                />
              </div>
              <div className="w-full">
                <Input
                  type="text"
                  placeholder="Last Name"
                  aria-label="Last Name"
                  name="lastName"
                  withLabel
                  labelType="floating"
                  variant="default"
                  register={register}
                  errors={errors}
                  disabled={emailRegistered}
                  className={inputClassName}
                />
              </div>
            </section>
            <section className="d-flex mt-4 mr-4">
              <div className="w-full">
                <Input
                  type="text"
                  placeholder="Mobile Number"
                  aria-label="Mobile Number"
                  name="mobile"
                  maxLength={18}
                  withLabel
                  labelType="floating"
                  variant="default"
                  register={register}
                  errors={errors}
                  disabled={emailRegistered}
                  className={inputClassName}
                  onKeyDown={handlePhoneKeyDown}
                />
              </div>
            </section>
            {['AU', 'NZ'].includes(selectedCountry) && (
              <section className="d-flex mt-4 mr-4">
                <div className="w-full">
                  <Input
                    type="text"
                    placeholder={
                      isAu
                        ? 'Australian Business Number (ABN)'
                        : 'New Zealand Business Number (NZBN)'
                    }
                    customPlaceholder={isAu ? 'ABN' : 'NZBN'}
                    aria-label={
                      isAu
                        ? 'Australian Business Number'
                        : 'New Zealand Business Number'
                    }
                    name="abn"
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-full ${inputClassName}`}
                  />
                  <a
                    href={
                      isAu
                        ? 'https://abr.business.gov.au/'
                        : 'https://www.nzbn.govt.nz/'
                    }
                    target="_blank"
                    rel="noreferrer"
                    className="abn-link"
                    style={{
                      opacity: emailRegistered ? '0.3' : '1.0',
                    }}
                  >
                    {isAu ? 'ABN' : 'NZBN'} Lookup
                  </a>
                </div>
              </section>
            )}
            <section className="mt-4 mb-5">
              <ParagraphText
                variant="reg"
                className={`section-title ${
                  emailRegistered ? 'disabled' : 'enabled'
                }`}
              >
                Business Address <span className="required-field">*</span>
              </ParagraphText>
              <div className="d-flex justify-content-between mt-4">
                <div className="w-100">
                  <Input
                    type="text"
                    placeholder="Company"
                    aria-label="Company"
                    name="company"
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-100 ${inputClassName}`}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between mt-4 gap-4">
                <div className="w-50">
                  <Input
                    type="text"
                    placeholder="Business Phone"
                    aria-label="Business Phone"
                    name="companyPhone"
                    maxLength={18}
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-100 ${inputClassName}`}
                    onKeyDown={handlePhoneKeyDown}
                  />
                </div>
              </div>
              <div className="d-flex mt-4">
                <div className="w-100">
                  <Input
                    type="text"
                    placeholder="Customer Address"
                    aria-label="Customer Address"
                    name="address"
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-100 ${inputClassName}`}
                  />
                </div>
              </div>
              <div className="d-flex mt-4 gap-4">
                <div className="w-30">
                  <Input
                    type="text"
                    placeholder={
                      selectedCountry === 'GB' ? 'City/Town' : 'City'
                    }
                    aria-label={selectedCountry === 'GB' ? 'City/Town' : 'City'}
                    name="city"
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-100 custom-mt ${inputClassName}`}
                  />
                </div>
                <div
                  className={`w-30 ${inputClassName}`}
                  style={{
                    marginTop: '-7px',
                  }}
                >
                  <Controller
                    control={control}
                    name="state"
                    render={({field: {onChange, name}}) => (
                      <Select
                        options={listOfStates}
                        width="full"
                        // selectLabel="Select State"
                        selectLabel={
                          selectedCountry === 'GB'
                            ? 'Select County'
                            : 'Select State'
                        }
                        selectedOption={state}
                        onChange={onChange}
                        errors={errors}
                        name={name}
                        hidden
                        className={`select mt-0 ${inputClassName}`}
                      />
                    )}
                  />
                </div>
                <div className="w-30">
                  <Input
                    type="text"
                    placeholder="Postal Code"
                    aria-label="Postal Code"
                    name="postCode"
                    withLabel
                    labelType="floating"
                    variant="default"
                    register={register}
                    errors={errors}
                    disabled={emailRegistered}
                    className={`w-100 ${inputClassName}`}
                  />
                </div>
              </div>
            </section>
            <section className="d-flex justify-content-end">
              <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit(handleOrderDetailContinue)}
                disabled={validatedEmail.length === 0}
              >
                Continue
              </Button>
            </section>
          </section>
        </section>
      </section>
      {showAccountExistsModal && (
        <Modal
          altBtn={<></>}
          openOnLoad
          variant="default"
          footer
          action
          btnAction={() => setShowAccountExistsModal(false)}
          onClose={() => setShowAccountExistsModal(false)}
          btnActionText="Ok"
          hideX
        >
          Looks like this email belongs to an existing client. Cannot proceed
          with order. Please enter a different email address.
        </Modal>
      )}
      {showUpgradeAccountModal && (
        <Modal
          altBtn={<></>}
          openOnLoad
          variant="lg"
          footer
          action
          btnAction={() => {
            navigate('/keap-partner-catalog', {
              state: {
                email: email,
                isUpgrade: true,
                linkType: linkType,
                selectedCountry: selectedCountry,
                keapPartnerId: keapPartnerId,
              },
            })
          }}
          onClose={() => setShowUpgradeAccountModal(false)}
          btnActionText="Update"
          hideX
          footerCancel
        >
          <div className="text-center">
            <ModalTitle variant="primary">
              An account with this email already exists
            </ModalTitle>
            <ParagraphText variant="reg" className="mt-1">
              Do you want to update this Thryv?
            </ParagraphText>
          </div>
        </Modal>
      )}
    </>
  )
}
